export default __webpack_public_path__ + "static/media/fifa-tnc-cn.e51836d2.svg";